import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_PERMISSION = createActionTypes('FETCH_PERMISSION');
export const FETCH_ALL_PERMISSION = createActionTypes('FETCH_ALL_PERMISSION');
export const GET_PERMISSION = createActionTypes('GET_PERMISSION');
export const CREATE_PERMISSION = createActionTypes('CREATE_PERMISSION');
export const UPDATE_PERMISSION = createActionTypes('UPDATE_PERMISSION');
export const DELETE_PERMISSION = createActionTypes('DELETE_PERMISSION');
